export const HomepageContent = () => {
  return (
    <div className="">
      {/* Section 1 */}
      <div className="row homepage-section">
        <div className="col-12 col-md-5 d-flex justify-content-center align-items-center">
          <img src="/static/graphics/homepage_graphic_2.svg" className="pe-md-5" />
          {/* <img className="homepage-graphic-notes" src="/static/graphics/homepage_graphic_2.svg" /> */}
        </div>
        <div className="col-12 col-md-7 pt-5 pt-md-0 d-flex-column align-self-center">
          <h5 className="pb-32 fw-semibold">The First On-Chain Music Platform</h5>
          <p className="">
            Arpeggi is the first and only blockchain music creation platform, providing tools for
            the next generation of creators to compose, collaborate and sell their music on-chain.
          </p>
        </div>
      </div>

      {/* Section 2 */}
      <div className="row homepage-section">
        <div className="col-12 col-md-6 pe-4 d-flex justify-content-center align-items-center">
          <a href={'/genesis-studio'}>
            <img
              className="img-fluid shadow-black-lg w-100"
              src="/static/graphics/homepage_studio.png"
            />
          </a>
        </div>
        <div className="col-12 offset-md-1 col-md-5 pt-5 pt-md-0 d-flex-column align-self-center">
          <h5 className="pb-32 fw-semibold">Arpeggi Studio</h5>
          <p className="pb-32">
            Arpeggi Studio is the only on-chain digital audio workstation (DAW). For the first time
            ever, musicians can compose and mint their songs as fully on-chain NFTs, allowing
            creators to take full advantage of blockchain technology. We built Arpeggi Studio for
            both experienced producers and new musicians alike, balancing ease of use and advanced
            feature sets.
          </p>
          <a href={'/genesis-studio'}>
            <button className="homepage-button homepage-button-blue">Get Started</button>
          </a>
        </div>
      </div>

      {/* Section 3 */}
      <div className="row homepage-section">
        <div className="col-12 col-lg-6 order-lg-2 pe-4 d-flex justify-content-center align-items-center">
          <div className="position-absolute d-none d-md-block">
            <img
              src="/static/graphics/homepage_click_to_play.svg"
              style={{ marginLeft: '-140%', marginTop: '-220%' }}
            />
          </div>
          <iframe
            className="static-box-shadow"
            src={'/player/102'}
            style={{ aspectRatio: '1', width: '100%', maxWidth: '400px' }}
          />
        </div>
        <div className="col-12 col-lg-6 order-lg-1 pt-5 pt-lg-0 d-flex-column align-self-center">
          <h5 className="pb-32 fw-semibold">The Genesis Collection</h5>
          <p className="pb-32">
            The Arpeggi Genesis Collection is the first project by Arpeggi Labs, enabling musicians
            to compose and mint original songs as fully on-chain NFTs for the first time ever. While
            anyone can compose a song in Arpeggi Studio, only holders of the Arpeggi Genesis Studio
            Pass can use the "Mint Song" feature to write their song to the chain. One Studio Pass
            enables its holder to mint one song, and only 600 Arpeggi Genesis Studio Passes will
            ever be created.{' '}
          </p>
          <p className="pb-32">
            The Genesis Collection is only the beginning. Blockchain technology has incredible
            potential to revolutionize how musicians create, collaborate and monetize their work,
            and we're excited to explore what's possible in our future releases.
          </p>
          <a href={'/listen'}>
            <button className="homepage-button homepage-button-yellow">Listen</button>
          </a>
        </div>
      </div>

      {/* Section 4 */}
      <div className="row homepage-section">
        <div
          className="col-12 col-lg-6 d-flex-column justify-content-center align-items-center align-self-center"
          style={{ height: '100%' }}
        >
          <a href="https://medium.com/@arpeggilabs/arpeggi-studio-4bf465348d51" target="_blank">
            <img
              className="img-fluid shadow-black-lg mb-5 w-100"
              src="/static/graphics/homepage_table.svg"
            />
          </a>
          <a
            href="https://artforall.io/score/arpeggi/0xd614e3b775b94794ea16a7843f31a56c36edcb09"
            target="_blank"
          >
            <img
              className="img-fluid shadow-black-lg align-self-end"
              src="/static/graphics/homepage_afa_score.svg"
              style={{ width: '80%', marginLeft: '20%' }}
            />
          </a>
        </div>
        <div className="col-12 offset-lg-1 col-lg-5 pt-5 pt-lg-0 d-flex-column align-self-center">
          <h5 className="pb-32 fw-semibold">100% On-Chain Music</h5>
          <p className="pb-1">
            Arpeggi is proud to be one of the only projects to have received a 100/100 “fully
            on-chain” score from the independent auditing service Art for All. Another example of a
            fully on-chain NFT platform is{' '}
            <u>
              <a href="https://www.artblocks.io/">Art Blocks</a>
            </u>
            . But what does it mean to be fully on-chain?
          </p>
          <p className="pb-32">
            Blockchain storage is incredibly expensive: storing an MP3 file on-chain would cost
            upwards of $100,000 in gas fees. To get around this, most NFT projects store image or
            music data on third-party services, and only store <i>references</i> to that data on the
            blockchain. This leads to a big problem: if the service hosting that data goes down for
            any reason, a holder is left with nothing!
          </p>
          <p className="pb-32">
            We wanted Arpeggi holders to truly own <i>all</i> their song’s data, so we leveraged our
            team’s deep experience in digital music to create a hyper-efficient song format: the{' '}
            <b>.arp</b> file. Creators can now store their song 100% on-chain at no more than the
            standard gas needed to mint any other NFT.
          </p>
          <a href="https://medium.com/@tg_luciano/b5edb877cb0f" target="_blank">
            <button className="homepage-button homepage-button-pink">How It Works</button>
          </a>
        </div>
      </div>

      {/* Section 5 */}
      <div className="row homepage-section">
        <div className="col-12 col-md-7 order-md-2 pe-4 d-flex justify-content-center align-items-center">
          <img className="img-fluid align-self-center" src="/static/graphics/homepage_venn.svg" />
        </div>
        <div className="col-12 col-md-5 order-md-1 pt-5 pt-md-0 d-flex-column align-self-center">
          <h5 className="pb-32 fw-semibold">
            Creators <span className="italic">and</span> Holders
          </h5>
          <p className="pb-32">
            Arpeggi is more than just a music creation tool -- it’s an ecosystem for music creators
            and listeners to collaborate and inspire each other. As the platform evolves, we’ll
            create tools to support the creation of world-class music and develop the infrastructure
            to facilitate artist and listener engagement in a decentralized and democratic manner.
          </p>
          <a href="https://discord.gg/52FXhdAkwn" target="_blank">
            <button className="homepage-button homepage-button-purple">Join Our Community</button>
          </a>
        </div>
      </div>

      {/* Team Section */}
      <div className="row d-flex justify-content-center homepage-section pb-200">
        <h5 className="fw-semibold text-center pb-5">OUR TEAM</h5>
        <div className="row col-12 col-lg-9 d-flex justify-content-start">
          <div className="col-12 col-md-6 col-lg-4 d-inline-flex">
            <a href="https://twitter.com/tg_luciano" target="_blank">
              <img className="homepage-pfp luciano-shadow" src="/static/images/luciano-pfp.png" />
            </a>
            <div>
              <p className="pfp-name">Kyle Dhillon</p>
              <p className="pfp-secondary-text">Technical Lead</p>
              <p className="pfp-text">
                Formerly Senior SWE @ Google
                <br />
                Computer Science, Princeton
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-inline-flex mt-5 mt-md-0">
            <a href="https://twitter.com/utility_maxi" target="_blank">
              <img className="homepage-pfp maxi-shadow" src="/static/images/maxi-pfp.png" />
            </a>
            <div>
              <p className="pfp-name">James Pastan</p>
              <p className="pfp-secondary-text">Growth Lead</p>
              <p className="pfp-text">
                Formerly PM @ MongoDB
                <br />
                Computer Science, Yale
              </p>
              {/* <p className="pfp-text">Utility NFT Guru<br />Seasoned Product Manager</p> */}
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-inline-flex mt-5 mt-lg-0">
            <a href="https://twitter.com/lp_wagmi" target="_blank">
              <img className="homepage-pfp wagmi-shadow" src="/static/images/wagmi-pfp.png" />
            </a>
            <div>
              <p className="pfp-name">Evan Dhillon</p>
              <p className="pfp-secondary-text">Project Lead</p>
              <p className="pfp-text">
                Formerly SWE @ Workday <br />
                Computer Science, WUSTL
              </p>
              {/* <p className="pfp-text">Software Engineer by Day<br />Blockchain Creator by Night</p> */}
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-inline-flex mt-5">
            <a href="https://twitter.com/ppbzach" target="_blank">
              <img className="homepage-pfp maxi-shadow" src="/static/images/zach-pfp.png" />
            </a>
            <div>
              <p className="pfp-name">PPB Zach</p>
              <p className="pfp-secondary-text">Principal Engineer</p>
              <p className="pfp-text">Computer Science, CMU</p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-inline-flex mt-5">
            <a href="https://twitter.com/_vividworker" target="_blank">
              <img className="homepage-pfp wagmi-shadow" src="/static/images/sound-pfp.png" />
            </a>
            <div>
              <p className="pfp-name">Vivid Worker</p>
              <p className="pfp-secondary-text">Principal Audio Engineer</p>
              <p className="pfp-text">Career Mix Engineer + Producer</p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-inline-flex mt-5">
            <a href="https://twitter.com/livieb_" target="_blank">
              <img className="homepage-pfp luciano-shadow" src="/static/images/liv-pfp.png" />
            </a>
            <div>
              <p className="pfp-name">Liv Bowman</p>
              <p className="pfp-secondary-text">Principal UX/UI Designer</p>
              <p className="pfp-text">Graphic Artist in Digital Spaces</p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-inline-flex mt-5">
            <a href="https://twitter.com/SassyBlack_" target="_blank">
              <img className="homepage-pfp wagmi-shadow" src="/static/images/sassy-pfp.png" />
            </a>
            <div>
              <p className="pfp-name">SassyBlack</p>
              <p className="pfp-secondary-text">Head of Artist Partnerships</p>
              <p className="pfp-text">High Priestess of Hologram Funk</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
